<div class="fullHeightWidth">
	<div class="loader">
		<i id="globalLoader" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
	</div>
</div>